import { __decorate, __metadata } from "tslib";
import { Computed } from './Model/Decorators';
import { injectable } from 'inversify';
export var ConnectionState;
(function (ConnectionState) {
    /** Has not tried to connect yet. */
    ConnectionState[ConnectionState["NotStarted"] = 0] = "NotStarted";
    /** Is connected. */
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    /** Is reconnecting after failing to connect, or being disconnected. */
    ConnectionState[ConnectionState["ReConnecting"] = 2] = "ReConnecting";
    /** Is disconnected and not trying to reconnect. */
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})(ConnectionState || (ConnectionState = {}));
export var ConnectionType;
(function (ConnectionType) {
    ConnectionType[ConnectionType["SignalR"] = 0] = "SignalR";
})(ConnectionType || (ConnectionType = {}));
var ConnectionInfo = /** @class */ (function () {
    function ConnectionInfo(connection, connectionName, connectionType) {
        this.connection = connection;
        this.connectionName = connectionName;
        this.connectionType = connectionType;
    }
    return ConnectionInfo;
}());
export { ConnectionInfo };
var ConnectionManager = /** @class */ (function () {
    function ConnectionManager() {
        this._connections = new Map();
    }
    ConnectionManager.prototype.registerConnection = function (connection, connectionName, connectionType) {
        if (!this._connections.has(connectionName)) {
            this._connections.set(connectionName, new ConnectionInfo(connection, connectionName, connectionType));
        }
    };
    Object.defineProperty(ConnectionManager.prototype, "connectionState", {
        get: function () {
            return this.connections.reduce(function (p, c) { return Math.max(p, c.connection.connectionState); }, ConnectionState.NotStarted);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionManager.prototype, "connections", {
        get: function () {
            return Array.from(this._connections.values());
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Computed(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ConnectionManager.prototype, "connectionState", null);
    ConnectionManager = __decorate([
        injectable()
    ], ConnectionManager);
    return ConnectionManager;
}());
export { ConnectionManager };
